import { FC } from "react";

interface ITitle extends React.ButtonHTMLAttributes<HTMLHeadingElement> {
  title: string;
}

const H4: FC<ITitle> = ({ title, ...props }: ITitle) => {
  return (
    <h4 {...props} className={`font-h4 text-h4 ${props.className}`}>
      {title}
    </h4>
  );
};
export default H4;
